import { isTruthy, Truthy } from '../../type-validation/generic/isTruthy';

export function assertIsTruthy<T>(value: T): asserts value is Truthy<T> {
  console.log('assertIsTruthy', typeof value, value);
  if (!isTruthy(value)) throw new Error(`Value ${value} is falsy`);
}
